import React from "react";

import { Stack, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

interface NavItemProps {
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
  onClick: () => void;
  hint?: {
    title: string;
    icon: React.ReactElement;
  };
}

export const NavItem: React.FC<NavItemProps> = ({ icon, label, isActive, onClick, hint }) => (
  <Stack
    direction="row"
    alignItems="center"
    sx={{
      height: "36px",
      padding: "0 5px",
      borderRadius: "20px",
      cursor: "pointer",
      flexShrink: 0,
      backgroundColor: isActive ? "#DBE8F5" : "transparent",
      "&:hover": { backgroundColor: "#ECF1F8" }
    }}
    gap="5px"
  >
    <Stack sx={{ padding: "16px" }} />
    <Stack
      direction="row"
      alignItems="center"
      gap="5px"
      onClick={onClick}
      sx={{ flex: 1, minWidth: 0, cursor: "pointer" }}
    >
      {icon}
      <Typography sx={{ color: "#20293C", fontWeight: 400, fontSize: "16px" }}>{label}</Typography>
      {hint && (
        <MaterialTooltip isShow title={hint.title} centerText>
          {hint.icon}
        </MaterialTooltip>
      )}
    </Stack>
  </Stack>
);
